<template>
    <!-- Backdrop when in mobile view -->
    <div
        class="fixed left-0 right-0 bottom-0 top-0 z-40 bg-black/50 transition-opacity duration-300 md:hidden"
        :class="[
            state.is_sidebar_open ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'
        ]"
        @click="state.is_sidebar_open = false"
    />

    <div class="flex h-[calc(100vh_-_var(--legacy-banner-height,0px))] overflow-hidden">
        <!-- Sidebar -->
        <div
            :class="[
                state.is_sidebar_open ? 'w-64 z-50' : 'w-20',
                'shrink-0',
                'transition-all duration-300 ease-in-out',
                // For mobile
                'absolute md:relative top-0 left-0 h-full bg-cinder-900',
                state.is_sidebar_open ? 'translate-x-0 z-50' : '-translate-x-full',
                'md:translate-x-0 md:z-0'
            ]"
        >
            <Sidebar
                :sidebar-open="state.is_sidebar_open"
                class="flex h-full"
                @close-sidebar="state.is_sidebar_open = false"
            />
        </div>
        <!-- Content area -->
        <div
            id="dashboard-content-area"
            class="relative z-0 flex flex-1 flex-col overflow-x-hidden transition-all duration-300"
            :class="[
                (state.is_sidebar_open || sidebarClosing)
                    ? 'md:opacity-100 md:pointer-events-auto opacity-0 pointer-events-none'
                    : 'opacity-100 pointer-events-auto'
            ]"
        >
            <CreateCampaignModal />
            <CreateOrgModal />
            <BackgroundActionToast />
            <Toaster
                position="top-right"
                :expand="false"
                :visibleToasts="5"
            />
            <ExportTableModal />
            <RevealEmailsModal />

            <!-- Site header -->
            <AppHeader
                :sidebar-open="state.is_sidebar_open"
                @toggle-sidebar="state.is_sidebar_open = !state.is_sidebar_open"
            />

            <main>
                <router-view :key="selfActiveOrganization ? `${selfActiveOrganization.id}` : `all-organizations`" />
            </main>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Sidebar from '@/partials/Sidebar.vue'
import CreateCampaignModal from '@/partials/modals/CreateCampaignModal.vue'
import AppHeader from '@/partials/AppHeader.vue'
import BackgroundActionToast from '@/components/toasts/BackgroundActionToast.vue'
import { Toaster } from 'vue-sonner'
import CreateOrgModal from '../partials/modals/CreateOrgModal.vue'
import ExportTableModal from '../partials/modals/ExportTableModal.vue'
import RevealEmailsModal from '../partials/modals/RevealEmailsModal.vue'

export default {
    name: 'DashboardView',

    components: {
        AppHeader,
        Sidebar,
        CreateCampaignModal,
        CreateOrgModal,
        BackgroundActionToast,
        ExportTableModal,
        RevealEmailsModal,
        Toaster,
    },

    data() {
        return {
            sidebarClosing: false,
            state: {
                is_sidebar_open: !window.matchMedia('(max-width: 767px)').matches,
            },
        }
    },

    computed: {
        ...mapGetters(['selfActiveOrganization', 'checkPermission']),
    },

    watch: {
        'state.is_sidebar_open'(newVal) {
        if (!newVal) {
            this.sidebarClosing = true
            setTimeout(() => {
                this.sidebarClosing = false
            }, 200)
        }
      },
    },
}
</script>
